import Heading from './heading';
import Microcopy from './microcopy';
import Quote from './quote';
import Subheading from './subheading';
import Text from './text';
import Label from './label';

export { Heading, Microcopy, Quote, Subheading, Text, Label };
